import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "store/actions";
import profileApi from "api/profile";
import { actions as projectActions } from "store/actions";
import useNotify from "hooks/useNotify";
import { scrollIntoView } from "utils/helper";

export default function UsePreferredCurrency() {
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.userDetails || {});
  const [isLoading, setIsLoading] = useState(false);
  const { notifyError, notifySuccess } = useNotify();

  const onEditPreferredCurrency = async (values) => {
    try {
      setIsLoading(true);
      const currencyId = values?.preferredCurrency;
      dispatch(
        projectActions.updatePreferredCurrency(
          { currencyId },
          async (isSuccess, err) => {
            if (isSuccess) {
              const userData = await profileApi.getUserProfileByIdApi(
                userDetails?.id
              );
              dispatch(actions.setUserDetails(userData));
              notifySuccess("Has been updated successfully");
              scrollIntoView("preferredCurrencySection");
            } else {
              notifyError(
                err?.data?.error ?? err?.message ?? "Something went wrong!"
              );
            }
          }
        )
      );
    } catch (err) {
      console.error(err);
      notifyError(err?.data?.error ?? err?.message ?? "Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  return { onEditPreferredCurrency, isPreferredCurrencyLoading: isLoading };
}
